import React, {useState} from 'react';
import {PlusOutlined} from '@ant-design/icons';
import classes from '../courses.module.css';
import SectionTitle from './SectionTitle';

/**
 * Аккордеон вопросов. Раскрытие сделано через grid-template-rows: 0fr -> 1fr,
 * а не max-height: у max-height скорость раскрытия зависит от длины ответа,
 * и короткие пункты открываются рывком, а длинные — с задержкой.
 *
 * items: [{q, a}] — уже приведённые к строкам текущего языка.
 */
const CourseFaq = ({titleId, items, defaultOpen = 0, tone = 'alt'}) => {
    const [openIndex, setOpenIndex] = useState(defaultOpen);

    return (
        <section className={tone === 'light' ? classes.section : classes.sectionAlt}>
            <div className={classes.containerNarrow}>
                <SectionTitle id={titleId} className={classes.sectionHead}/>
                <div className={classes.faqList}>
                    {items.map((item, i) => {
                        const isOpen = openIndex === i;
                        return (
                            <div
                                key={item.q}
                                className={`${classes.faqItem} ${isOpen ? classes.faqItemOpen : ''}`}
                            >
                                <button
                                    type="button"
                                    className={classes.faqHead}
                                    onClick={() => setOpenIndex(isOpen ? -1 : i)}
                                    aria-expanded={isOpen}
                                >
                                    <span>{item.q}</span>
                                    <PlusOutlined className={classes.faqSign}/>
                                </button>
                                <div
                                    className={`${classes.faqAnswerWrap} ${isOpen ? classes.faqAnswerWrapOpen : ''}`}
                                >
                                    <div className={classes.faqAnswerInner}>
                                        <p className={classes.faqAnswer}>{item.a}</p>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default CourseFaq;
